import { render, staticRenderFns } from "./jrDetailnew.vue?vue&type=template&id=d127085e&scoped=true&"
import script from "./jrDetailnew.vue?vue&type=script&lang=js&"
export * from "./jrDetailnew.vue?vue&type=script&lang=js&"
import style0 from "./jrDetailnew.vue?vue&type=style&index=0&id=d127085e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d127085e",
  null
  
)

export default component.exports